import axios from 'axios';
import { ApiResponse, PhieuCham, TieuChi } from '../../../shared/types';

const API_BASE = '/api/v1/phieu-cham';

class PhieuChamService {
  async getPhieuChamList(): Promise<ApiResponse<PhieuCham[]>> {
    const response = await axios.get<ApiResponse<PhieuCham[]>>(API_BASE);
    return response.data;
  }

  async getTieuChiList(phieuId: number): Promise<ApiResponse<TieuChi[]>> {
    const response = await axios.get<ApiResponse<TieuChi[]>>(`${API_BASE}/${phieuId}/tieuchi`);
    return response.data;
  }

  async createPhieuCham(data: any): Promise<ApiResponse> {
    const response = await axios.post<ApiResponse>(API_BASE, data);
    return response.data;
  }

  async updatePhieuCham(phieuId: number, data: any): Promise<ApiResponse> {
    const response = await axios.put<ApiResponse>(`${API_BASE}/${phieuId}`, data);
    return response.data;
  }

  async deletePhieuCham(phieuId: number): Promise<ApiResponse> {
    const response = await axios.delete<ApiResponse>(`${API_BASE}/${phieuId}`);
    return response.data;
  }
}

export default new PhieuChamService(); 